<div class="page-wrapper">
  <div class="blob blob-main"></div>
  <div class="blob blob-accent"></div>

  <div class="page-container">

    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img
          src="../../assets/images/Logo.svg"
          alt="Nishwik Logo"
          class="img-fluid"
        />
      </div>
      <div class="nav-right">
        Already have an account?
        <a routerLink="/login" class="link-btn">Sign In →</a>
      </div>
    </header>

    <main class="main-content">

      <!-- Left Info Panel -->
      <section class="info-panel">
        <span class="badge">Society Management Platform</span>

        <h1 class="headline">
          Join Your<br /><span class="accent">Society. Digitally.</span>
        </h1>

        <p class="panel-desc">
          Connect with your housing society, pay maintenance, raise complaints,
          track visitors, and stay informed — all from one streamlined platform.
        </p>

        <div class="features-list">
          <div class="feature-item">
            <div class="f-icon ic-1">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"/>
              </svg>
            </div>
            <div class="f-content">
              <div class="f-title">Maintenance &amp; Billing</div>
              <div class="f-desc">Pay dues online, view history and outstanding invoices</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon ic-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <div class="f-content">
              <div class="f-title">Complaints &amp; Notices</div>
              <div class="f-desc">Raise tickets and receive society announcements instantly</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon ic-3">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3 20a6 6 0 0 1 12 0M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.87"/>
              </svg>
            </div>
            <div class="f-content">
              <div class="f-title">Visitor Management</div>
              <div class="f-desc">Pre-approve guests and track gate entry logs in real time</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Right Form Panel -->
      <section class="form-panel">
        <div class="signup-card">
          <div class="card-top-bar"></div>
          <div class="card-inner">

            <div class="card-eyebrow">Society OS · Registration</div>
            <h2 class="card-title">Create Your Account</h2>
            <p class="card-subtitle">Fill in your details to get started</p>

            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">

              <!-- Section 01: Personal Information -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num">01</div>
                  <h3 class="section-label">Personal Information</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>First Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                      </svg>
                      <input type="text" formControlName="firstName" placeholder="John"
                        [class.error]="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.invalid" />
                    </div>
                    <small class="field-error"
                      *ngIf="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.hasError('required')">
                      First name is required.
                    </small>
                  </div>
                  <div class="input-group">
                    <label>Last Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                      </svg>
                      <input type="text" formControlName="lastName" placeholder="Doe"
                        [class.error]="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.invalid" />
                    </div>
                    <small class="field-error"
                      *ngIf="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.hasError('required')">
                      Last name is required.
                    </small>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Email Address <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                      <input type="email" formControlName="email" placeholder="john@example.com"
                        [class.error]="signupForm.get('email')?.touched && signupForm.get('email')?.invalid" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('required')">Email is required.</small>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('email')">Enter a valid email address.</small>
                  </div>
                  <div class="input-group">
                    <label>Mobile Number <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                        <line x1="12" y1="18" x2="12.01" y2="18"/>
                      </svg>
                      <input type="tel" formControlName="mobileNumber" placeholder="9876543210"
                        [class.error]="signupForm.get('mobileNumber')?.touched && signupForm.get('mobileNumber')?.invalid" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('mobileNumber')?.touched && signupForm.get('mobileNumber')?.hasError('pattern')">
                      Enter a valid 10-digit mobile number.
                    </small>
                  </div>
                </div>

                <!-- Flat / Unit info -->
                <div class="form-row">
                  <div class="input-group">
                    <label>Flat / Unit Number <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"/>
                      </svg>
                      <input type="text" formControlName="flatNumber" placeholder="A-101"
                        [class.error]="signupForm.get('flatNumber')?.touched && signupForm.get('flatNumber')?.invalid" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('flatNumber')?.touched && signupForm.get('flatNumber')?.hasError('required')">Flat number is required.</small>
                  </div>
                  <div class="input-group">
                    <label>Wing / Tower</label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
                      </svg>
                      <input type="text" formControlName="wing" placeholder="A Wing" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Section 02: Account Security -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num">02</div>
                  <h3 class="section-label">Account Security</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Username <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M12 8v4M12 16h.01"/>
                      </svg>
                      <input type="text" formControlName="username" placeholder="johndoe_101"
                        [class.error]="signupForm.get('username')?.touched && signupForm.get('username')?.invalid" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('username')?.touched && signupForm.get('username')?.hasError('required')">Username is required.</small>
                  </div>
                  <div class="input-group" *ngIf="otpSent">
                    <label>Verify OTP <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                      </svg>
                      <input type="text" formControlName="otp" placeholder="6-digit code" maxlength="6" class="otp-field"
                        [class.error]="signupForm.get('otp')?.touched && signupForm.get('otp')?.invalid" />
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                      <input type="password" formControlName="password" placeholder="Min. 6 characters"
                        [class.error]="signupForm.get('password')?.touched && signupForm.get('password')?.invalid" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('minlength')">
                      Password must be at least 6 characters.
                    </small>
                    <small class="field-error" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('required')">
                      Password is required.
                    </small>
                  </div>
                  <div class="input-group">
                    <label>Confirm Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                      <input type="password" formControlName="confirmPassword" placeholder="Re-enter password"
                        [class.error]="signupForm.hasError('mismatch') && signupForm.get('confirmPassword')?.touched" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.hasError('mismatch') && signupForm.get('confirmPassword')?.touched">
                      Passwords do not match.
                    </small>
                    <small class="field-error" *ngIf="signupForm.get('confirmPassword')?.touched && signupForm.get('confirmPassword')?.hasError('required')">
                      Confirm password is required.
                    </small>
                  </div>
                </div>
              </div>

              <button type="submit" class="btn-submit" [disabled]="signupForm.invalid">
                <span>Complete Registration</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18">
                  <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                </svg>
              </button>

              <p class="terms-text">
                By registering, you agree to our
                <a routerLink="/policy/terms">Terms of Service</a> and
                <a routerLink="/policy/privacy">Privacy Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </section>

    </main>
  </div>

  <footer class="bottom-bar">
    <div class="foot-inner">
      <span class="copyright">© 2026 Nishwik Society OS. All rights reserved.</span>
      <div class="foot-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms &amp; Conditions</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </div>
  </footer>
</div>